const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const { GET_FAVOURITES, UPDATE_FAVOURITES } = require("./constants");

const {
  getFavouritesSuccess,
  getFavouritesError,
  updateFavouritesSuccess,
  updateFavouritesError,
} = require("./actions");



const getFavourite = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_FAVOURITES),
    mergeMap((action) =>
      marketplaceApi.favourites
        .getFavourites(marketplace, action.payload.userId)
        .then((response) => getFavouritesSuccess(response.data))
        .catch((error) => getFavouritesError(error))
    )
  );


const updateFavourite = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(UPDATE_FAVOURITES),
    mergeMap((action) =>
      marketplaceApi.favourites
        .updateFavourites(marketplace, {
          user_id: action.payload.userId,
          products_ids: action.payload.productsId,
        })
        .then((response) => updateFavouritesSuccess(response.data))
        .catch((error) => updateFavouritesError(error))
    )
  );




module.exports = {
  getFavourite,
  updateFavourite,
};
